<template>
  <div>
    <div v-if="singleDevice">
      <single-device-dashboard />
    </div>
    <div v-else>
    <v-row v-if="false">
      <v-col cols="12">
        {{ userInfo }}xxx
        {{ commands }}
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col cols="12">
        {{ typelist }}
        {{ commands }}
        {{ "deviceList" }}
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col cols="12">
        {{ deviceData }}
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        :lg="item.width"
        v-for="(item, i) in numberDefs"
        :key="i"
      >
        <number-view
          :title="item.title"
          :xnumber="deviceData[item.field] ? `${deviceData[item.field]}` : '0'"
          :number="getValueNumber(item)"
          :unit="item.unit"
          :desc="item.desc"
          :icon="item.icon"
          :initial="item.initial"
          :color="item.color ? item.color : 'red'"
          v-if="(any_dc_device && !item.dc_hide) || !any_dc_device"
        ></number-view>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="isMobile ? 12 : 4">
        <map-card :height="row1Height" title="Location" :markers="deviceList">
        </map-card>
      </v-col>

      <v-col :cols="isMobile ? 12 : 3" v-if="userInfo.role_name !== 'guest' && userInfo.role_name !== 'user'">
        <data-card
          title="Control Group"
          :height="!isMobile ? row1Height : `max-content`"
        >
          <v-list-item v-if="!commands || commands.length == 0">
            <v-list-item-avatar>
              <v-icon>mdi-checkbox-blank-off-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>
                <span style="color: #00ffff">
                  No Realtime Control for this device
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template v-for="item in commands">
            <v-list-item
              :key="item"
              v-if="
                (any_dc_device && !commandDefs[item].dc_hide) || !any_dc_device
              "
            >
              <v-list-item-avatar>
                <v-icon
                  :color="
                    commandDefs[item].color ? commandDefs[item].color : 'blue'
                  "
                  light
                  >{{ commandDefs[item].icon }}</v-icon
                >
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  style="
                    font-weight: 700;
                    font-size: 0.85rem;
                    color: #00ffff;
                    letter-spacing: 0.3px;
                  "
                >
                  {{ commandDefs[item].caption }}
                </v-list-item-title>

                <v-list-item-subtitle
                  style="
                    font-size: 0.85rem;
                    color: rgba(200, 255, 255, 0.8);
                    margin-top: 2px;
                    line-height: 1.4;
                    font-weight: 400;
                  "
                >
                  {{ commandDefs[item].desc }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon @click="openDialog(item)">
                  <v-icon color="cyan lighten-2"
                    >mdi-dots-horizontal-circle-outline</v-icon
                  >
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </data-card>
      </v-col>
      <v-col :cols="isMobile ? 12 : (userInfo.role_name !== 'guest' && userInfo.role_name !== 'user') ? 5 : 8">
        <v-card class="device-list-card pb-0">
          <v-list-item class="device-list-header">
            <v-list-item-content>
              <v-list-item-title class="device-list-title">
                <v-icon left small color="#00ffff">mdi-lan-connect</v-icon>
                DEVICE LIST
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn outlined small color="#00ffff" @click="openExportDialog" class="btn-outline">
                <v-icon left small>mdi-file-excel</v-icon>
                Export
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-divider class="cyan-divider"></v-divider>

          <div v-if="isMobile">
            <v-expansion-panels class="py-4">
              <v-expansion-panel
                v-for="(item, i) in paginatedDeviceList"
                :key="i"
                class="custom-data-accordion mb-2"
              >
                <v-expansion-panel-header>
                  <strong class="text-cyan">{{ item.name }}</strong>
                  <template v-slot:actions>
                    <v-icon color="text-cyan"> mdi-menu-down </v-icon>
                  </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="pa-0 ma-0">
                  <v-list class="custom-data-accordion pa-0 ma-0" dense>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Power</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        (parseFloat(item.power) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      }}</v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Voltage</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        (parseFloat(item.voltage) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      }}</v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Last Data Time</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        item.lastdata
                      }}</v-list-item-action>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>RSSI</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        item.rssi_desc
                      }}</v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>SNR</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        item.snr_desc
                      }}</v-list-item-action>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Spreading Factor</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>{{
                        item.spreading_desc
                      }}</v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="d-flex justify-space-between align-center pa-3">
              <v-btn
                small
                outlined
                color="cyan"
                :disabled="mobilePage === 1"
                @click="mobilePage--"
              >
                Prev
              </v-btn>

              <span class="text-caption">
                Page {{ mobilePage }} / {{ totalMobilePages }}
              </span>

              <v-btn
                small
                outlined
                color="cyan"
                :disabled="mobilePage === totalMobilePages"
                @click="mobilePage++"
              >
                Next
              </v-btn>
            </div>
          </div>

          <!-- DESKTOP: tampilkan v-data-table -->
          <v-data-table
            v-else
            :headers="headers"
            :items="deviceListTable"
            :items-per-page="8"
            :footer-props="{
              'items-per-page-options': [5, 8],
              'disable-items-per-page': true,
            }"
            class="custom-data-table elevation-1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog max-width="600" v-model="dialog" :style="{ zindex: 10001 }">
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="#102242" dark v-if="!controlProgress"
                >{{ dialogOpt.title }} to
                {{ deviceData["count"] }} devices</v-toolbar
              >
              <v-toolbar color="#102242" dark v-if="controlProgress"
                >{{ dialogOpt.title }} {{ controlCount }} of
                {{ deviceData["count"] }} devices</v-toolbar
              >
              <v-card-text color="primary">
                <template v-if="dialogName == 'relaystatus'">
                  <v-switch color="#00ffff" v-model="dialogOpt.relaystatus">
                    <template v-slot:label>
                      <span style="color: #00ffff">
                        Send switch command:
                        {{ dialogOpt.relaystatus ? "ON" : "OFF" }}
                      </span>
                    </template>
                  </v-switch>
                </template>
                <template v-if="dialogName == 'totalisator'">
                  <v-text-field
                    label="Energy Meter (kWh)"
                    hide-details="auto"
                    v-model="dialogOpt.energyMeter"
                  ></v-text-field>
                </template>
                <template v-if="dialogName == 'brightness'">
                  <v-row class="mt-4">
                    <v-col cols="6">
                      <v-text-field
                        label="Brightness"
                        hide-details="auto"
                        v-model="dialogOpt.brightness"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-slider
                        v-model="dialogOpt.brightness"
                        class="mt-4"
                      ></v-slider>
                    </v-col>
                  </v-row>
                </template>
                <template v-if="dialogName == 'schedule'">
                  <v-text-field
                    label="Time ON (HH:MM)"
                    hide-details="auto"
                    v-model="dialogOpt.timeOn"
                  ></v-text-field>
                  <v-text-field
                    label="Time OFF (HH:MM)"
                    hide-details="auto"
                    v-model="dialogOpt.timeOff"
                  ></v-text-field>
                </template>
                <template v-if="dialogName == 'timesync'">
                  <v-switch color="primary" v-model="dialogOpt.timesyncStatus">
                    <template v-slot:label>
                      <span style="color: #00ffff">
                        Synchronize Time:
                        {{ dialogOpt.timesyncStatus ? "ON" : "OFF" }}
                      </span>
                    </template>
                  </v-switch>
                </template>

                <template v-if="dialogName == 'newdimschedule'">

                  <v-row v-for="(item, i) in dimIndex" :key="'row-' + i">
                    <v-col cols="3" :key="'start-' + item + '-' + i">
                      <v-text-field
                        cols="4"
                        :label="
                          item === 'M'
                            ? 'Main Start (MS)'
                            : 'Schedule ' + item + ' Start (' + item + 'S)'
                        "
                        hide-details="auto"
                        v-model="
                          dialogOpt.dimSchedule[item.toLowerCase() + 's']
                        "
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" :key="'end-' + item + '-' + i">
                      <v-text-field
                        cols="4"
                        :label="
                          item === 'M'
                            ? 'Main End (ME)'
                            : 'Schedule ' + item + ' End (' + item + 'E)'
                        "
                        hide-details="auto"
                        v-model="
                          dialogOpt.dimSchedule[item.toLowerCase() + 'e']
                        "
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" :key="'level-' + item + '-' + i">
                      <v-text-field
                        cols="4"
                        :label="
                          item === 'M'
                            ? 'Main Level (ML)'
                            : 'Schedule ' + item + ' Level (' + item + 'L)'
                        "
                        hide-details="auto"
                        v-model="
                          dialogOpt.dimSchedule[item.toLowerCase() + 'l']
                        "
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" :key="'slider-' + item + '-' + i">
                      <v-slider
                        v-model="
                          dialogOpt.dimSchedule[item.toLowerCase() + 'l']
                        "
                        class="mt-4"
                      ></v-slider>
                    </v-col>
                  </v-row>
                </template>
                <template v-if="dialogName == 'kwh_rate'">
                  <v-text-field
                    label="kWh Rate"
                    hide-details="auto"
                    v-model="dialogOpt.kwhRate"
                  ></v-text-field>
                </template>
                <template v-if="dialogName == 'currentdata'">
                  <v-card-subtitle>
                    <span style="color: #00ffff"
                      >Request Current Data of {{ deviceData["name"] }}</span
                    ></v-card-subtitle
                  >
                </template>
                <template v-if="dialogName == 'interval'">
                  <v-text-field
                    label="Reporting Interval (hour)"
                    hide-details="auto"
                    v-model="dialogOpt.reportingInterval"
                  ></v-text-field>
                </template>
                <template v-if="dialogName == 'set_threshold'">
                  <v-text-field
                    label="ON Threshold (Lux)"
                    hide-details="auto"
                    v-model="dialogOpt.luxmax"
                  ></v-text-field>
                  <v-text-field
                    label="OFF Threshold (Lux)"
                    hide-details="auto"
                    v-model="dialogOpt.luxmin"
                  ></v-text-field>
                </template>
                <template v-if="dialogName == 'driver_model'">
                  <v-card-subtitle>
                    <span style="color: #00ffff"
                      >Request Driver Model & Firmware Version of {{ deviceData["name"] }}</span
                    ></v-card-subtitle
                  >
                </template>
                <template v-if="dialogName == 'device_config'">
                  <v-card-subtitle>
                    <span style="color: #00ffff"
                      >Request Device Configuration of {{ deviceData["name"] }}</span
                    ></v-card-subtitle
                  >
                </template>
                <template v-if="dialogName == 'maintenance'">
                  <v-switch color="#00ffff" v-model="dialogOpt.maintenance">
                    <template v-slot:label>
                      <span style="color: #00ffff">
                        Update Maintenance Status</span
                      >
                    </template>
                  </v-switch>
                  <v-textarea
                    name="maintenance-text"
                    label="Notes"
                    hint="Type notes on update Maintenance Status"
                    rows="2"
                    v-model="dialogOpt.maintenanceNotes"
                  ></v-textarea>
                </template>
              </v-card-text>
              <v-card-actions :class="isMobile ? 'flex-column' : 'justify-end'">
                <v-progress-circular
                  v-if="controlLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>

                <!-- JSON Button -->
                <v-btn
                  outlined
                  color="#00ffff"
                  class="btn-outline ml-2 mb-2"
                  :block="isMobile"
                  @click="json_dialog = true"
                  v-if="!controlLoading && dialogName == 'newdimschedule'"
                >
                  <span style="color: #00ffff">JSON</span>
                </v-btn>

                <!-- Cancel Button -->
                <v-btn
                  outlined
                  color="#00ffff"
                  class="btn-outline mb-2"
                  :block="isMobile"
                  @click="dialog.value = false"
                  v-if="!controlLoading"
                >
                  <span style="color: #00ffff">Cancel</span>
                </v-btn>

                <!-- Submit Button -->
                <v-btn
                  color="#00ffff"
                  class="btn-filled"
                  dark
                  :block="isMobile"
                  @click="processRealtimeControl(dialogName, dialogOpt)"
                  v-if="!controlLoading"
                >
                  <span style="color: #102242">Submit</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>

    <v-dialog
      v-model="json_dialog"
      :fullscreen="isFullscreen"
      :max-width="isFullscreen ? undefined : 800"
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card
        class="json-editor-card d-flex flex-column"
        :style="{
          height: isFullscreen ? '100vh' : '70vh', // <── tinggi dinamis
        }"
      >
        <v-card-title class="py-2 d-flex align-center justify-space-between">
          <span>JSON Editor</span>

          <div>
            <v-btn
              @click="toggleFullscreen"
              icon
              color="#00ffff"
              class="ml-auto"
              variant="text"
            >
              <v-icon>
                {{ isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen" }}
              </v-icon>
            </v-btn>

            <v-btn
              icon
              color="#00ffff"
              class="ml-auto"
              variant="text"
              @click="json_dialog = false"
              v-if="!controlLoading && dialogName == 'newdimschedule'"
            >
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="json-editor-container flex-grow-1 pa-0">
          <json-editor
            ref="jsonEditor"
            v-model="dialogOpt.dimSchedule"
            mode="code"
            :show-btns="false"
            style="background-color: rgba(15, 35, 70, 0.5) !important"
          ></json-editor>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Result Dialog -->
    <v-dialog v-model="resultDialog" max-width="550" persistent>
      <v-card class="device-list-card">
        <v-card-title class="text-cyan">
          <v-icon left color="#00ffff">mdi-information-outline</v-icon>
          Process Complete
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row class="mb-4">
            <v-col cols="6" class="text-center">
              <v-chip color="green darken-2" dark class="px-4 py-2 font-weight-bold" label>
                <v-icon left>mdi-check-circle</v-icon>
                Success: {{ controlSuccess }}
              </v-chip>
            </v-col>
            <v-col cols="6" class="text-center">
              <v-chip color="red darken-2" dark class="px-4 py-2 font-weight-bold" label>
                <v-icon left>mdi-alert-circle</v-icon>
                Failed: {{ controlFail }}
              </v-chip>
            </v-col>
          </v-row>
          
          <div v-if="controlFail > 0 && controlMessages.length > 0" class="mt-4">
            <div class="text-subtitle-2 mb-2 text-cyan font-weight-bold">Errors:</div>
            <v-sheet
              color="rgba(0, 0, 0, 0.4)"
              class="pa-3 rounded"
              outlined
              style="border: 1px solid rgba(0, 255, 255, 0.2); max-height: 250px; overflow-y: auto;"
            >
              <div v-for="(msg, idx) in displayedControlMessages" :key="idx" class="text-body-2 white--text mb-1">
                {{ msg }}
              </div>
              <div v-if="!showAllErrors && controlMessages.length > 5" class="mt-2 text-center">
                <v-btn
                  x-small
                  color="#00ffff"
                  outlined
                  class="btn-outline"
                  @click="showAllErrors = true"
                >
                  ...and {{ controlMessages.length - 5 }} more (click to show all)
                </v-btn>
              </div>
            </v-sheet>
          </div>
        </v-card-text>
        <v-card-actions class="pb-4 px-4 justify-end">
          <v-btn
            color="cyan"
            class="black--text btn-filled"
            min-width="110"
            @click="resultDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Group Control Submitted Snackbar -->
    <v-snackbar
      v-model="groupControlSubmitted"
      :timeout="4000"
      color="teal darken-3"
      top
      right
      elevation="10"
      class="group-control-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon left color="white">mdi-clock-check-outline</v-icon>
        <span class="white--text">{{ groupControlMessage }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          small
          v-bind="attrs"
          @click="groupControlSubmitted = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Export Dialog -->

    <v-dialog v-model="exportDialog" max-width="500">
      <v-card class="device-list-card">
        <v-card-title class="text-cyan">
          <v-icon left color="#00ffff">mdi-file-export</v-icon>
          Export Energy Report
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="6">
              <v-menu
                v-model="menuFrom"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exportFrom"
                    label="From Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exportFrom"
                  @input="menuFrom = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menuTo"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="exportTo"
                    label="To Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="cyan"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="exportTo"
                  @input="menuTo = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-radio-group v-model="exportType" row dark>
            <v-radio label="Summary (per Area)" value="summary" color="cyan"></v-radio>
            <v-radio label="Detail (per Lamp)" value="detail" color="cyan"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="cyan"
            class="btn-outline mr-2"
            min-width="110"
            @click="exportDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="cyan"
            class="black--text btn-filled"
            min-width="110"
            @click="doExport"
            :loading="controlLoading"
            :disabled="controlLoading"
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row v-if="false">
      <v-col cols="6">
        <v-card class="cyan darken-2" height="300"></v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="cyan darken-2" height="300"></v-card>
      </v-col>
    </v-row>
    </div>
  </div>
</template>

<script>
import NumberView from "@/components/Cards/NumberView";
import MapCard from "@/components/Cards/MapCard";
import DataCard from "@/components/Cards/DataCard";
import JsonEditor from "vue-json-editor";
import ControlActions from "@/mixins/ControlActions";
import NotificationActions from "@/mixins/NotificationActions"; // <-- 1. Import Mixin
import SingleDeviceDashboard from "@/views/SmartLight/SingleDeviceDashboard.vue"; // <-- Import SingleDeviceDashboard

import xstore from "@/store/index.js";



export default {
  mixins: [ControlActions, NotificationActions], // <-- 2. Gunakan Mixin
  components: {
    NumberView,
    MapCard,
    DataCard,
    JsonEditor,
    SingleDeviceDashboard,
  },
  data: () => ({
    mobilePage: 1,
    mobilePerPage: 5,
    text2: "x",
    dialog: false,
    dialogName: "",
    userInfo: {},
    exportDialog: false,
    menuFrom: false,
    menuTo: false,
    exportFrom: new Date().toISOString().substr(0, 10),
    exportTo: new Date().toISOString().substr(0, 10),
    exportType: "detail",
    json_dialog: false,
    isFullscreen: false,
    resultDialog: false,
    showAllErrors: false,
    // singleDevice: false
    controlSuccess: 0,
    controlFail: 0,
    controlMessages: [],
    controlCount: 0,
    counterLabel: "",
    controlProgress: false,
    // Group control background submission state
    groupControlSubmitted: false,
    groupControlMessage: "",
    dialogOpt: {
      title: "-",
      relaystatus: false,
    },
    controlLoading: false,
    row1Height: 540,
    removeDefs: {
      schedule: "newdimschedule", // bila ada dimschedule, maka schedule dihilangkan
    },
    commandDelays: {
      default: 1000,
      relaystatus: 5000,
      brightness: 5000,
      currentdata: 500,
      kwh_rate: 500,
      maintenance: 500,
      timesync: 5000,
      schedule: 5000,
      newdimschedule: 5000,
    },
    commandDelayDevice: {
      "pju-avnet2": {
        relaystatus: 5000,
        brightness: 5000,
        currentdata: 500,
        schedule: 10000,
        newdimschedule: 10000,
      },
    },
    typeDefs: {
      default: [
        "relaystatus",
        "brightness",
        "currentdata",
        "kwh_rate",
        "maintenance",
        "schedule",
      ],
      "pju-dc": ["relaystatus", "brightness", "currentdata", "schedule"],
      "pju-telkom": [
        "relaystatus",
        "totalisator",
        "brightness",
        "kwh_rate",
        "maintenance",
        "schedule",
      ],
      "pju-icode": [
        "relaystatus",
        "brightness",
        "currentdata",
        "kwh_rate",
        "maintenance",
        "timesync",
        "schedule",
      ],
      "pju-avnet": [
        "relaystatus",
        "brightness",
        "currentdata",
        "kwh_rate",
        "maintenance",
        "schedule",
        "timesync",
        "interval",
        "driver_model",
        "device_config",
      ],
      "pju-avnet2": [
        "relaystatus",
        "brightness",
        "currentdata",
        "kwh_rate",
        "maintenance",
        "timesync",
        "interval",
        "driver_model",
        "device_config",
        "newdimschedule",
      ],
    },
    // commands: ["relaystatus", "brightness", "currentdata", "kwh_rate", "maintenance", "schedule"],
    // commands: ["relaystatus", "totalisator", "brightness", "schedule", "kwh_rate"],
    commandDefs: {
      relaystatus: {
        caption: "Relay Status",
        desc: "Set Relay ON/OFF",
        title: "Set Relay ON/OFF",
        icon: "mdi-lightbulb-on-outline",
        color: "red",
      },
      totalisator: {
        caption: "Totalisator",
        desc: "Reset Energy Meter",
        title: "Reset Energy Meter",
        icon: "mdi-lightning-bolt-circle",
        color: "blue",
      },
      brightness: {
        caption: "Brightness",
        desc: "Set Lamp Brightness",
        title: "Set Lamp Brightness (10 - 100)",
        icon: "mdi-brightness-6",
        color: "yellow darken-2",
      },
      schedule: {
        caption: "Schedule",
        desc: "Set ON/OFF Schedule",
        title: "Set ON/OFF Schedule",
        icon: "mdi-calendar-clock",
        color: "purple",
      },
      newdimschedule: {
        caption: "Dimming Schedule",
        desc: "Update Dimming Schedule",
        title: "Update Dimming Schedule",
        icon: "mdi-calendar-clock",
        color: "purple",
      },
      timesync: {
        caption: "Time Synchronization Status",
        desc: "Set Synchronization ON/OFF",
        title: "Set Synchronization ON/OFF",
        icon: "mdi-timer-sync-outline",
        color: "blue darken-3",
      },
      currentdata: {
        caption: "Request Current Data",
        desc: "Request Current Data",
        title: "Request Current Data",
        icon: "mdi-lightbulb-on-outline",
        color: "green",
      },
      kwh_rate: {
        caption: "Setting kWh Rate",
        desc: "Setting kWh Rate",
        title: "Setting kWh Rate",
        icon: "mdi-tag-multiple-outline",
        dc_hide: true,
        color: "green",
      },
      maintenance: {
        caption: "Maintenance Status",
        desc: "Update Maintenance Status",
        title: "Update Maintenance Status",
        icon: "mdi-cog-outline",
        dc_hide: true,
        color: "grey darken-3",
      },
      interval: {
        caption: "Set Report Interval",
        desc: "Set Report Interval",
        title: "Set Device Reporting Interval",
        icon: "mdi-timer-cog-outline",
        color: "green darken-2",
      },
      driver_model: {
        caption: "Get Driver Model",
        desc: "Driver Model & Firmware Version",
        title: "Get Driver Model and Firmware Version",
        icon: "mdi-information-outline",
        color: "blue darken-3",
      },
      device_config: {
        caption: "Get Device Configuration",
        desc: "Device Configuration",
        title: "Get Device Configuration",
        icon: "mdi-wrench-outline",
        color: "blue darken-3",
      },
      set_threshold: {
        caption: "Set On-Off Threshold",
        desc: "Set On-Off Threshold",
        title: "Set On-Off Threshold",
        icon: "mdi-cogs",
        color: "red darken-3",
      },
    },
    openDialog(vname) {
      console.log("xvname", vname);
      this.dialogName = vname;
      if (typeof this.commandDefs[vname] !== "undefined") {
        this.dialogOpt.title = this.commandDefs[vname].title;
      } else {
        this.dialogOpt.title = vname;
      }
      this.dialog = true;
      this.controlLoading = false;
    },
    numberDefs: [
      {
        field: "count",
        title: "Total Device",
        unit: "",
        icon: "mdi-ceiling-light-multiple-outline",
        color: "light-blue darken-2",
        width: "3",
      },
      {
        field: "percentOn",
        title: "% Device ON",
        unit: "%",
        icon: "mdi-lightbulb-on",
        color: "orange darken-1",
        width: "3",
        decimal: 2,
      },
      {
        field: "countOn",
        title: "Device ON",
        unit: "",
        icon: "mdi-lightbulb-on",
        color: "orange darken-1",
        width: "3",
      },
      {
        field: "countOff",
        title: "Device OFF",
        unit: "",
        icon: "mdi-lightbulb-off-outline",
        color: "grey darken-3",
        width: "3",
      },
      {
        field: "countOffline",
        title: "Device Offline",
        unit: "",
        icon: "mdi-network-off",
        color: "grey darken-1",
        width: "3",
      },
      {
        field: "countError",
        title: "Warning",
        unit: "",
        icon: "mdi-alert-decagram",
        color: "orange lighten-3",
        width: "3",
      },
      {
        field: "countMaint",
        title: "Maintenance",
        unit: "",
        icon: "mdi-cog",
        color: "grey darken-1",
        width: "3",
      },
      {
        field: "usage_today",
        title: "Today Usage",
        unit: "kWh",
        icon: "mdi-lightning-bolt",
        color: "yellow darken-3",
        width: "3",
        decimal: 2,
      },
      {
        field: "totalCurrent",
        title: "Total Current",
        unit: "A",
        initial: "I",
        color: "green darken-3",
        width: "3",
        decimal: 2,
        dc_hide: true
      },
      {
        field: "usage_month",
        title: "Month Usage",
        unit: "kWh",
        icon: "mdi-lightning-bolt",
        color: "yellow darken-3",
        width: "3",
        decimal: 2,
      },
      {
        field: "rp_today",
        title: "Estimated Today Cost",
        unit: "Rp",
        icon: "mdi-cash-multiple",
        color: "green darken-1",
        width: "3",
        decimal: 2,
      },
      {
        field: "rp_month",
        title: "Estimated Month Cost",
        unit: "Rp",
        icon: "mdi-cash-multiple",
        color: "green darken-1",
        width: "3",
        decimal: 2,
      },
      // {
      //   field: "totalPower",
      //   title: "Total Power",
      //   unit: "W",
      //   initial: "W",
      //   color: "deep-purple darken-2",
      //   width: "3",
      //   decimal: 2,
      //   dc_hide: true
      // },
      // {
      //   field: "averageVoltage",
      //   title: "Average Voltage",
      //   unit: "V",
      //   initial: "V",
      //   color: "teal lighten-1",
      //   width: "3",
      //   decimal: 2,
      //   dc_hide: true
      // },
      // {
      //   field: "avgPowerFactor",
      //   title: "Average Power Factor",
      //   unit: "",
      //   icon: "mdi-lightning-bolt-circle",
      //   color: "pink darken-1",
      // },
    ],
    headers: [
      {
        text: "Device Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: "Power",
        align: "start",
        sortable: false,
        value: "power",
        decimal: 2,
      },
      {
        text: "Voltage",
        align: "start",
        sortable: false,
        value: "voltage",
        decimal: 2,
      },
      {
        text: "Last Data Time",
        align: "start",
        sortable: false,
        value: "lastdata",
      },
      {
        text: "RSSI",
        align: "start",
        sortable: false,
        value: "rssi_desc",
      },
      {
        text: "SNR",
        align: "start",
        sortable: false,
        value: "snr_desc",
      },
      {
        text: "Spreading Factor",
        align: "start",
        sortable: false,
        value: "spreading_desc",
      },
    ],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    paginatedDeviceList() {
      const start = (this.mobilePage - 1) * this.mobilePerPage;
      const end = start + this.mobilePerPage;
      return this.deviceList.slice(start, end);
    },

    totalMobilePages() {
      return Math.ceil(this.deviceList.length / this.mobilePerPage);
    },

    any_dc_device() {
      // Perbaikan: any_dc_device harus berdasarkan list yang sedang dilihat,
      // bukan global agar tidak menyembunyikan kontrol AC saat filter pencarian menghasilkan AC saja.
      return this.deviceList.some((device) => device.devicetype === "pju-dc");
    },
    typelist() {
      // let names = {}
      let names = {};
      this.deviceList.forEach((item) => {
        names[item.devicetype] = (names[item.devicetype] || 0) + 1;
      });
      return Object.keys(names);
      // return names
    },
    commands() {
      if (this.userInfo.role_name !== "guest" && this.userInfo.role_name !== "user") {
        let vlist = this.typelist;
        // let vresult = this.typeDefs['default']
        let vresult = null;
        console.log("command-list", vlist);
        vlist.forEach((item) => {
          console.log("command-foreach", item, this.typeDefs[item]);
          if (vresult === null) {
            vresult = this.typeDefs[item];
            if (typeof vresult === "undefined") {
              vresult = this.typeDefs["default"];
            }
            console.log("command-foreach-1", vresult);
          } else {
            let vcheck = this.typeDefs["default"];
            if (typeof this.typeDefs[item] !== "undefined") {
              vcheck = this.typeDefs[item];
            }
            vresult = this.intersect(vresult, vcheck);
          }
        });
        if (vresult === null) {
          vresult = [];
        }
        vresult = this.removeDuplicates(vresult);
        return vresult;
        // return this.getCommands()
        // return ["relaystatus", "brightness", "currentdata", "kwh_rate", "maintenance", "schedule"]
      }
      return [];
    },
    deviceSelectedList() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      return vitem;
    },
    deviceData() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      if (vitem && typeof vitem.info !== "undefined") {
        let xinfo = {
          id: vitem.id,
          name: vitem.name,
          caption: vitem.caption,
          type: vitem.type,
        };
        let result = {
          ...xinfo,
          ...vitem.info,
        };
        console.log("device Data Items", vitem);
        return result;
      } else {
        console.log("deviceData blank");
        return {};
      }
      // return vitem
      // if (vitem && Object.keys(vitem).length) {
      //   if (vitem.type === "device") {
      //     return vitem;
      //   }
      // }
      // return {};
    },
    deviceListTable() {
      let result = this.deviceList;
      return this.formatData(this.headers, result);
    },
    deviceList() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      if (vitem && Object.keys(vitem).length) {
        if (typeof vitem.listDevices !== "undefined") {
          // return this.formatData(this.headers, vitem.listDevices)
          return vitem.listDevices;
        }
      }
      return [];
    },
    singleDevice() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      if (vitem && Object.keys(vitem).length) {
        if (vitem.type === "device") {
          return true;
        }
      }
      return false;
    },
    title1() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      if (vitem && Object.keys(vitem).length) {
        if (vitem.type === "device") {
          return "Single Device";
        } else {
          return "Multi Device";
        }
      } else {
        return "All Devices";
      }
      //return 'test-1'
    },
    title2() {
      let vitem = this.$store.getters["devices/deviceTreeSelected"];
      console.log(vitem);
      if (vitem && Object.keys(vitem).length) {
        if (vitem.type === "device") {
          return vitem.name;
        } else {
          return vitem.caption + ": " + vitem.name;
        }
      } else {
        return "";
      }
      // return 'test-2'
    },
    displayedControlMessages() {
      if (this.showAllErrors) {
        return this.controlMessages;
      }
      return this.controlMessages.slice(0, 5);
    },
  },
  methods: {
    openExportDialog() {
      this.exportDialog = true;
    },
    async doExport() {
      const vthis = this;
      
      // Ambil filter saat ini dari store
      const filters = this.$store.getters["devices/currentFilter"] || {};
      
      try {
        vthis.controlLoading = true;
        const params = {
          from: vthis.exportFrom,
          to: vthis.exportTo,
          type: vthis.exportType,
          kecamatan: filters.kecamatan || 'all',
          meteran: filters.meteran || 'all',
          project: filters.project || 'all',
          tahun: filters.tahun || 'all'
        };

        console.log("Exporting with params:", params);

        const res = await this.$axios.get('spju/report/energy', { params });
        const xlist = res.data.data;

        if (!xlist || xlist.length === 0) {
          alert("No data found for the selected range/filters");
          vthis.controlLoading = false;
          return;
        }

        // BOM (\uFEFF) Agar Excel mengenali encoding UTF-8 dengan benar
        let csv = "\uFEFF";
        
        if (vthis.exportType === "summary") {
          csv += "No,Kecamatan,Total Devices,Total Usage (kWh),Total Cost (Rp)\n";
          xlist.forEach((item, index) => {
            const row = [
              index + 1,
              `"${item.kecamatan || ''}"`,
              item.device_count || 0,
              `"${(parseFloat(item.total_usage) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}"`,
              `"${(parseFloat(item.total_cost) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}"`
            ];
            csv += row.join(",") + "\n";
          });
        } else {
          csv += "No,Nama Perangkat,Display Name,ID Perangkat,Kecamatan,Meter ID,Status,Total Usage (kWh),Total Cost (Rp),Last Data Time\n";
          xlist.forEach((item, index) => {
            const row = [
              index + 1,
              `"${item.devicename || ''}"`,
              `"${item.displayname || ''}"`,
              `"${item.devicecode || ''}"`,
              `"${item.kecamatan || ''}"`,
              `"${item.meter_id || ''}"`,
              `"${item.status || ''}"`,
              `"${(parseFloat(item.total_usage) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}"`,
              `"${(parseFloat(item.total_cost) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}"`,
              `"${item.last_data || ''}"`
            ];
            csv += row.join(",") + "\n";
          });
        }

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        const filename = `PJU_Energy_Report_${vthis.exportFrom}_to_${vthis.exportTo}.csv`;
        
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        vthis.exportDialog = false;
        vthis.$toast.success("Export successful!");
      } catch (error) {
        console.error("Export error:", error);
        alert("Failed to export data: " + (error.message || "Internal server error"));
      } finally {
        vthis.controlLoading = false;
      }
    },
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    getDelay(vdevicetype, vcommand) {
      let vresult = this.commandDelays["default"];
      if (this.commandDelays[vcommand]) {
        vresult = this.commandDelays[vcommand];
      }
      if (typeof this.commandDelayDevice[vdevicetype] !== "undefined") {
        if (
          typeof this.commandDelayDevice[vdevicetype][vcommand] !== "undefined"
        ) {
          vresult = this.commandDelayDevice[vdevicetype][vcommand];
        }
      }
      return vresult;
    },
    removeDuplicates(array1 = []) {
      // return array1
      // tidak menampilkan item yang item this.removeDefs[items] ada dalam list array1

      let result = array1.filter((item) => {
        if (typeof this.removeDefs[item] !== "undefined") {
          let vcheck = this.removeDefs[item];
          console.log("vcheck", item, vcheck, array1.indexOf(vcheck), array1);
          return array1.indexOf(vcheck) === -1;
        }
        return true;
        // return typeof this.removeDefs[item] === 'undefined'
      });
      return result;

      // hilangkan item dalam array1 yang ditunjuk oleh item yang ada di thsi.removeDefs
      //   let result = array1.filter((item) => {
      //     if (typeof this.removeDefs[item] !== 'undefined') {
      //       let vcheck = this.removeDefs[item]
      //       return typeof array1[vcheck] === 'undefined'
      //     }
      //     return true
      //     // return typeof this.removeDefs[item] === 'undefined'
      //   })
      //   return result
    },
    intersect(array1 = [], array2 = []) {
      console.log("intersect", array1, array2);
      return array1.filter((value) => array2.includes(value));
    },
    listCommands() {
      console.log("listCommands");
    },
    anyDcDevice() {
      console.log(
        "sssss any dc device",
        this.$store.getters["devices/anyDcDevice"]
      );
      return this.$store.getters["devices/anyDcDevice"];
    },
    formatData(vformat, vdata) {
      let result = [];
      for (let i = 0; i < vdata.length; i++) {
        let row = {};
        let xrow = vdata[i];
        for (let j = 0; j < vformat.length; j++) {
          let xformat = vformat[j];
          let xfield = xformat["value"];
          if (typeof xrow[xfield] !== "undefined") {
            if (typeof xformat["decimal"] !== "undefined") {
              row[xfield] = Number(xrow[xfield]).toLocaleString("en-US", {
                minimumFractionDigits: xformat["decimal"],
                maximumFractionDigits: xformat["decimal"],
              });
            } else {
              row[xfield] = xrow[xfield];
            }
          }
        }
        result.push(row);
      }
      return result;
    },
    getValueNumber(item) {
      let result = "0";
      if (typeof item.field !== "undefined") {
        if (typeof this.deviceData[item.field] !== "undefined") {
          let val = Number(this.deviceData[item.field]);
          if (typeof item.decimal !== "undefined") {
            result = val.toLocaleString("en-US", {
              minimumFractionDigits: item.decimal,
              maximumFractionDigits: item.decimal,
            });
          } else {
            result = val.toLocaleString("en-US");
          }
        }
      }
      return result;
    },
    onSelection(selection) {
      console.log("on-selection", selection);
    },
    async controlSingle(dialogName, dialogOpt, deviceCode, silent = false) {
      console.log("controlSingle", dialogName);
      let res = { code: 500, message: 'Unknown error' };
      switch (dialogName) {
        case "relaystatus":
          res = await this.controlRelay(
            deviceCode,
            dialogOpt.relaystatus,
            dialogOpt.relayNotes,
            silent
          );
          break;
        case "currentdata":
          res = await this.requestCurrentData(deviceCode, silent);
          break;
        case "kwh_rate":
          res = await this.controlKwhRate(deviceCode, dialogOpt.kwhRate, silent);
          break;
        case "maintenance":
          res = await this.updateMaintenance(
            deviceCode,
            dialogOpt.maintenance,
            dialogOpt.maintenanceNotes,
            silent
          );
          break;
        case "schedule":
          res = await this.controlSchedule(
            deviceCode,
            dialogOpt.timeOn,
            dialogOpt.timeOff,
            dialogOpt.relayNotes,
            silent
          );
          break;
        case "newdimschedule":
          res = await this.updateDimSchedule(deviceCode, dialogOpt.dimSchedule, silent);
          break;
        case "brightness":
          res = await this.controlBrightness(
            deviceCode,
            dialogOpt.brightness,
            dialogOpt.relayNotes,
            silent
          );
          break;
        case "timesync":
          res = await this.controlTimeSync(
            deviceCode,
            dialogOpt.timesyncStatus,
            dialogOpt.timesyncNotes,
            silent
          );
          break;
        case "totalisator":
          res = await this.controlTotalisator(
            deviceCode,
            dialogOpt.energyMeter,
            dialogOpt.totalisatorNotes,
            silent
          );
          break;
        case "interval":
          res = await this.controlSendInterval(
            deviceCode,
            dialogOpt.reportingInterval,
            dialogOpt.intervalNotes,
            silent
          );
          break;
        case "driver_model":
          res = await this.controlDriverModel(deviceCode, silent);
          break;
        case "device_config":
          res = await this.controlDeviceConfig(deviceCode, silent);
          break;
        case "set_threshold":
          res = await this.controlSendThreshold(
            deviceCode,
            dialogOpt.luxmax,
            dialogOpt.luxmin,
            dialogOpt.thresholdNotes,
            silent
          );
          break;
      }
      return res;
    },
    resetControlStatus() {
      this.controlSuccess = 0;
      this.controlFail = 0;
      this.controlMessages = [];
      this.controlCount = 0;
      this.counterLabel = "";
      this.showAllErrors = false;
      this.resultDialog = false;
    },
    async processRealtimeControl(dialogName, dialogOpt) {
      this.resetControlStatus();
      this.controlProgress = true;
      this.controlLoading = true;

      console.log("prc", dialogName, dialogOpt);
      const vlist = this.deviceList;
      if (!vlist || vlist.length === 0) {
        this.controlProgress = false;
        this.controlLoading = false;
        return;
      }

      // Bangun payload params berdasarkan action
      const devicecodes = vlist.map(v => v.devicecode);
      let params = {};
      switch (dialogName) {
        case 'relaystatus':
          params = { state: dialogOpt.relaystatus, notes: dialogOpt.relayNotes };
          break;
        case 'brightness':
          params = { brightness: dialogOpt.brightness, notes: dialogOpt.relayNotes };
          break;
        case 'currentdata':
          params = {};
          break;
        case 'kwh_rate':
          params = { kwhRate: dialogOpt.kwhRate };
          break;
        case 'maintenance':
          params = { maintenance: dialogOpt.maintenance, notes: dialogOpt.maintenanceNotes };
          break;
        case 'timesync':
          params = { syncStatus: dialogOpt.timesyncStatus, notes: dialogOpt.timesyncNotes };
          break;
        case 'schedule':
          params = { timeOn: dialogOpt.timeOn, timeOff: dialogOpt.timeOff, notes: dialogOpt.relayNotes };
          break;
        case 'newdimschedule':
          params = { dimSchedule: dialogOpt.dimSchedule };
          break;
        case 'totalisator':
          params = { energyMeter: dialogOpt.energyMeter, notes: dialogOpt.totalisatorNotes };
          break;
        case 'interval':
          params = { reportingInterval: dialogOpt.reportingInterval, notes: dialogOpt.intervalNotes };
          break;
        case 'driver_model':
          params = {};
          break;
        case 'device_config':
          params = {};
          break;
        case 'set_threshold':
          params = { luxmax: dialogOpt.luxmax, luxmin: dialogOpt.luxmin, notes: dialogOpt.thresholdNotes };
          break;
        default:
          params = {};
      }

      try {
        this.counterLabel = `Mengirim perintah untuk ${devicecodes.length} perangkat...`;
        const result = await this.$store.dispatch('devices/submitGroupControl', {
          devicecodes,
          action: dialogName,
          params,
        });

        this.controlProgress = false;
        this.controlLoading = false;
        this.dialog = false;
        this.dialogOpt.maintenanceNotes = '';

        // Tampilkan pesan konfirmasi bahwa proses berjalan di background
        // Cek result.success karena wrapper API selalu mengembalikan { success: true/false, data, code, message }
        if (result && result.success) {
          this.groupControlSubmitted = true;
          this.groupControlMessage = result.data && result.data.message
            ? result.data.message
            : `Perintah untuk ${devicecodes.length} perangkat sedang diproses`;
        } else {
          // Fallback jika backend error — tampilkan dialog error
          this.controlFail = devicecodes.length;
          this.controlMessages = [result ? (result.message || 'Gagal mengirim perintah ke server') : 'Gagal mengirim perintah ke server'];
          this.resultDialog = true;
        }
      } catch (err) {
        console.error('processRealtimeControl error:', err);
        this.controlProgress = false;
        this.controlLoading = false;
        this.controlFail = devicecodes.length;
        this.controlMessages = [err.message || 'Terjadi kesalahan saat mengirim perintah'];
        this.resultDialog = true;
      }
    },

  },
  mounted() {},
  created() {
    this.userInfo = xstore.getters.USER_INFO;
  },
  watch: {
    json_dialog(val) {
      if (val) {
        this.$nextTick(() => {
          // tunggu elemen benar-benar ada
          const editorEl = this.$el.querySelector(".ace_editor");
          if (editorEl) {
            editorEl.style.height = "100%";
            editorEl.style.minHeight = "100vh";
            // panggil resize internal jsoneditor kalau tersedia
            if (this.$refs.jsonEditor && this.$refs.jsonEditor.editor) {
              this.$refs.jsonEditor.editor.resize();
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
/* === JSON EDITOR FULLSCREEN FIX === */
.json-editor-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.json-editor-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden;
}

/* Paksa semua wrapper jsoneditor penuh tinggi */
.jsoneditor-vue,
.jsoneditor,
.jsoneditor-outer,
.ace_editor,
.ace_scroller,
.ace_content {
  flex: 1 !important;
  height: 100% !important;
  width: 100% !important;
  background-color: rgba(15, 35, 70, 0.5) !important;
}

/* Ubah warna teks biar kontras */
.ace_content,
.ace_line {
  color: #e0f7fa !important;
}

/* Optional: ubah warna gutter (nomor baris) */
.ace_gutter {
  background-color: rgba(10, 25, 50, 0.6) !important;
  color: #00ffff !important;
}

/* Tambahan penting — biar Ace Editor nggak auto-shrink */
.jsoneditor-mode-code .ace_editor {
  min-height: 100% !important;
}

/* Toolbar jsoneditor tetap terlihat */
.jsoneditor-menu {
  flex-shrink: 0;
}

/* CARD UTAMA */
.device-list-card {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 255, 255, 0.15);
  transition: all 0.25s ease;
  overflow: hidden;
}

.device-list-card:hover {
  box-shadow: 0 6px 18px rgba(0, 255, 255, 0.25);
  transform: translateY(-2px);
}

/* HEADER */
.device-list-header {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.device-list-title {
  color: #00ffff !important;
  font-weight: 600;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* DIVIDER */
.cyan-divider {
  border-color: #00ffff !important;
}

.custom-data-accordion {
  background-color: rgba(1, 9, 23, 0.5) !important;
  color: #00ffff !important;
  width: 100%;
}

:deep(.v-expansion-panel-content__wrap) {
  padding: 0 !important;
}

.v-list-item {
  border-bottom: 1px solid rgba(0, 255, 255, 0.1);
}

/* DATA TABLE */
.custom-data-table {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
}

/* Header (TH) */
.custom-data-table >>> th {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 2px solid #00eaff !important;
}

/* Isi tabel (TD) */
.custom-data-table >>> td {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  border-bottom: 1px solid rgba(0, 234, 255, 0.2) !important;
}

/* Hover efek baris */
.custom-data-table >>> tr:hover td {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

/* Footer background dan border */
.custom-data-table >>> .v-data-footer {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top: 1px solid #00ffff !important;
  color: #00ffff !important;
}

/* Text & select dropdown di footer */
.custom-data-table >>> .v-data-footer__select,
.custom-data-table >>> .v-select__selection,
.custom-data-table >>> .v-select__selections,
.custom-data-table >>> .v-input__slot,
.custom-data-table >>> .v-input__append-inner {
  color: #00ffff !important;
}

/* Ikon pagination kiri (previous) */
.custom-data-table >>> .v-data-footer__icons-before .v-icon {
  color: #00ffff !important;
  fill: #00ffff !important;
}

/* Ikon pagination kanan (next) */
.custom-data-table >>> .v-data-footer__icons-after .v-icon {
  color: #00ffff !important;
  fill: #00ffff !important;
}

/* ✅ Ikon caret dropdown items-per-page */
.custom-data-table >>> .v-input__append-inner .v-icon {
  color: #00ffff !important;
}

/* Tooltip dan teks pagination */
.custom-data-table >>> .v-data-footer__pagination {
  color: #00ffff !important;
}
/* 🔥 Paksa ikon footer pagination berwarna #00ffff */
.custom-data-table >>> .theme--light.v-data-footer .v-icon,
.custom-data-table >>> .theme--dark.v-data-footer .v-icon {
  color: #00ffff !important;
  fill: #00ffff !important;
}

/* Kalau Vuetify pakai icon di pagination section */
.custom-data-table >>> .v-data-footer__pagination .v-icon {
  color: #00ffff !important;
  fill: #00ffff !important;
}

/* CHIP STATUS */
.status-chip {
  font-weight: 500;
  text-transform: capitalize;
}

.text-cyan {
  color: rgba(0, 234, 255, 0.9) !important;
  text-shadow: 0 0 4px rgba(0, 234, 255, 0.3);
}
/* === Background Global === */
.v-application {
  background-color: #0b1120 !important;
  color: #e0f7fa;
}

/* === CARD GENERAL STYLE === */
.v-card {
  background: rgba(15, 25, 35, 0.65) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 234, 255, 0.2);
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 234, 255, 0.08);
  color: #e0f7fa !important;
  max-width: 100%;
}

/* === HEADER CARD === */
.v-list-item.grey.lighten-3 {
  background: rgba(0, 234, 255, 0.08) !important;
  color: #00eaff !important;
  border-bottom: 1px solid rgb(0, 234, 255);
}

/* === TABLE === */
.v-data-table {
  background: rgba(12, 20, 30, 0.5) !important;
  color: #e0f7fa !important;
  border-radius: 12px;
}

.v-data-table-header th {
  background: rgba(0, 234, 255, 0.1) !important;
  color: #00eaff !important;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
}

.v-data-table tbody tr:hover {
  background: rgba(0, 234, 255, 0.08) !important;
  transition: background 0.3s ease;
}

/* === ICON === */
.v-icon {
  color: #00eaff !important;
}

/* === BUTTONS === */
.v-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.v-btn.primary {
  background: linear-gradient(90deg, #00eaff, #00bcd4);
  color: #0b1120 !important;
  box-shadow: 0 0 12px rgba(0, 234, 255, 0.4);
}

.v-btn.primary:hover {
  box-shadow: 0 0 18px rgba(0, 234, 255, 0.7);
}

/* === SWITCH & SLIDER === */
.v-input--switch__thumb {
  background-color: #00eaff !important;
}

.v-slider .v-slider__thumb {
  border: 2px solid #00eaff;
  box-shadow: 0 0 6px rgba(0, 234, 255, 0.6);
}

/* === TEXT FIELDS === */
.v-input input,
.v-text-field input,
.v-textarea textarea {
  color: #00eaff !important;
  background: rgba(0, 0, 0, 0.3);
}

.v-label {
  color: rgba(0, 234, 255, 0.8) !important;
}

.v-input__control {
  color: #00eaff !important;
}

/* === DIALOG === */
.v-dialog .v-card {
  background: rgba(20, 35, 45, 0.8) !important;
  border: 1px solid rgba(0, 234, 255, 0.25);
  box-shadow: 0 0 25px rgba(0, 234, S255, 0.2);
}

/* === TITLE === */
.v-toolbar {
  background: linear-gradient(
    90deg,
    rgba(0, 234, 255, 0.2),
    rgba(0, 234, 255, 0.05)
  ) !important;
  color: #00eaff !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.v-input--switch.v-input--is-label-active .v-input--switch__track {
  background-color: rgba(0, 255, 255, 0.4) !important; /* OFF state */
}

.v-input--switch .v-input--switch__thumb {
  background-color: #00ffff !important; /* Thumb */
}

.v-input--switch .v-label {
  color: #00ffff !important;
}

.v-textarea textarea {
  color: #00eaff !important;
  font-weight: 500;
}

/* BUTTONS */
.btn-outline {
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.btn-outline:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
}

.btn-filled {
  background-color: #00ffff !important;
  color: #1e1e2f !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.btn-filled:hover {
  background-color: #18ffff !important;
  transform: scale(1.03);
}
</style>
